export default "__VITE_ASSET__3b7S2Nve__"